import { render, staticRenderFns } from "./treeView.vue?vue&type=template&id=4c5483ee&scoped=true&"
import script from "./treeView.vue?vue&type=script&lang=js&"
export * from "./treeView.vue?vue&type=script&lang=js&"
import style0 from "./treeView.vue?vue&type=style&index=0&id=4c5483ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5483ee",
  null
  
)

export default component.exports